import * as yup from 'yup';

export enum PensionPlanType {
  SingleLife,
  JointSurvivor,
  LumpSum,
}

interface PensionChangeItemDTO {
  AssetId: string;
  Name: string;
  IsPrincipal: boolean;
  PlanType: PensionPlanType;
  MonthlyPayment: number;
  DistributionAtRetirement: boolean;
  DistributionAge: number | null;
  IsInflationAdjusted: boolean;
  InflationRate: number | null;
  SurvivorBenefit: number;
  LumpSumAmount: number;
}

export interface FormValues {
  WhatIfKey: string;
  WhatIfType: number;
  WhatIfTypeName: string;
  Pensions: PensionChangeItemDTO[];
}

export const FORM_SCHEMA = yup.object().shape({
  Pensions: yup.array().of(
    yup.object().shape({
      MonthlyPayment: yup
        .number()
        .nullable()
        .when('PlanType', {
          is: (val: PensionPlanType) => val !== PensionPlanType.LumpSum,
          then: schema =>
            schema
              .required('Please enter a monthly payment.')
              .min(0, 'Monthly payment must be zero or greater.'),
        }),
      DistributionAge: yup
        .number()
        .nullable()
        .when('DistributionAtRetirement', {
          is: false,
          then: schema =>
            schema
              .required('Please enter a distribution age.')
              .min(1, 'Distribution age must be at least 1.'),
        }),
      InflationRate: yup
        .number()
        .nullable()
        .when(['IsInflationAdjusted', 'PlanType'], {
          is: (isInflationAdjusted: boolean, planType: PensionPlanType) =>
            isInflationAdjusted === true && planType !== PensionPlanType.LumpSum,
          then: schema =>
            schema
              .required('Please enter an inflation rate.')
              .min(0, 'Inflation rate must be zero or greater.'),
        }),
      SurvivorBenefit: yup
        .number()
        .nullable()
        .when('PlanType', {
          is: PensionPlanType.JointSurvivor,
          then: schema =>
            schema
              .required('Please enter a survivor benefit percentage.')
              .min(0, 'Survivor benefit must be between 0% and 100%.')
              .max(100, 'Survivor benefit must be between 0% and 100%.'),
        }),
    }),
  ),
});
